import { supabase } from '@/lib/supabase/client';

export interface SiteSetting {
  id: string;
  key: string;
  value: string | null;
  description: string | null;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function getAllSiteSettings(): Promise<SiteSetting[]> {
  try {
    const { data, error } = await supabase
      .from('site_settings')
      .select('*')
      .order('key', { ascending: true });

    if (error) throw error;

    return (data || []).map(row => ({
      id: row.id,
      key: row.key,
      value: row.value,
      description: row.description,
      updatedBy: row.updated_by,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    }));
  } catch (error) {
    console.error('Error fetching site settings:', error);
    return [];
  }
}

export async function updateSiteSetting(key: string, value: string, userId: string): Promise<boolean> {
  try {
    const { error } = await supabase
      .from('site_settings')
      .update({
        value,
        updated_by: userId
      })
      .eq('key', key);

    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error updating site setting:', error);
    return false;
  }
}